module.exports = __webpack_public_path__ + "img/3.a1316078.png";